<app-base-page-template>
  <app-base-page-content-template>
    <app-business-access-grid
      [businessKey]="businessKey">
    </app-business-access-grid>
  </app-base-page-content-template>
</app-base-page-template>
